// FIXME: this file should be splitted in multiple files and go to domain/model/application/...
// Represent all possible additional heating choices
export enum AdditionalHeating {
  Electric = 'electric',
  GasFireplace = 'gasFireplace',
  Oil = 'oilHeating',
  OilFireplace = 'oilFireplace',
  Other = 'other',
  WoodBurningStove = 'woodBurningStove',
  WoodFireplace = 'woodFireplace',
}

// All basement condition choices
export enum BasementCondition {
  NoBasement = 'noBasement',
  FullyFinished = 'fullyFinished',
  HalfFinished = 'halfFinished',
  NotFinished = 'notFinished',
}

// All payment status on the car
export enum CarPaymentStatus {
  Paid = 'paid',
  Financed = 'financed',
  Leased = 'leased',
}

// All possible car security device choices
export enum CarSecurity {
  SherlockAntiTheft = 'sherlockAntiTheft',
  TagTracking = 'tagTracking',
  AudibleAlarm = 'audibleAlarm',
}

// All possible state when car was bought
export enum CarCondition {
  Used = 'used',
  New = 'new',
  Demo = 'demo',
}

// All possible primary usage
export enum CarUsage {
  Work = 'work',
  School = 'school',
  Pleasure = 'pleasure',
}

// All possible car claim description
export enum CarClaimDescription {
  Collision = 'collision',
  Fire = 'fire',
  GlassBreakage = 'glassBreakage',
  Hail = 'hail',
  Liability = 'liability',
  LiabilityCollision = 'liabilityAndCollision',
  OtherNonResponsible = 'otherNonResponsible',
  Theft = 'theft',
  Vandalism = 'vandalism',
}

// These car claims can be responsible or not
export const CarClaimDescriptionChargeableList: CarClaimDescription[] = [
  CarClaimDescription.Collision,
  CarClaimDescription.Liability,
  CarClaimDescription.LiabilityCollision,
];

// Represent all possible co insured situation choices
export enum CoInsuredSituation {
  Employed = 'employed',
  Retired = 'retired',
  Student = 'student',
}

// All possible conviction description - Keep it in blocks to make it easier to compare with Fortus documentation
export enum DrivingConvictionDescription {
  // Severity minor (37)
  CrowdingDriversSeat = 'crowdingDriversSeat',
  DefectiveBrakes = 'defectiveBrakes',
  DistractedDriving = 'distractedDriving',
  DriversLicenceViolations = 'driversLicenseViolations',
  FailureToCarryInsuranceCard = 'failureToCarryInsuranceCard',
  FailureToProduceEvidenceOfInsurance = 'failureToProduceEvidenceOfInsurance',
  FailingToShareRoad = 'failingToShareRoad',
  FailingToSignal = 'failingToSignal',
  FailureToUseSeatbelts = 'failureToUseSeatbelts',
  FailingToYield = 'failingToYield',
  FailingToYieldPedestrian = 'failingToYieldPedestrian',
  FollowingTooClosely = 'followingTooClosely',
  HeadlightOffenses = 'headlightOffenses',
  ImproperDrivingBusLane = 'improperDrivingBusLane',
  ImproperLaneChange = 'improperLaneChange',
  ImproperOpeningDoor = 'improperOpeningDoor',
  ImproperPassing = 'improperPassing',
  ImproperTowing = 'improperTowing',
  ImproperTurn = 'improperTurn',
  ImproperDividedHighway = 'improperDividedHighway',
  InsecureLoad = 'insecureLoad',
  MinorConvictionNotSpecified = 'minorConvictionNotSpecified',
  ObstructingTraffic = 'obstructingTraffic',
  Overload = 'overload',
  ProhibitedHandHeldDevice = 'prohibitedHandHeldDevice',
  RailwayCrossing = 'railwayCrossing',
  Speeding = 'speeding',
  StopSign = 'stopSign',
  TrafficLight = 'trafficLight',
  TrailerPassenger = 'trailerPassenger',
  UnnecessaryNoise = 'unnecessaryNoise',
  UnnecessarySlowDriving = 'unnecessarySlowDriving',
  UnsafeMove = 'unsafeMove',
  UnsafeTurn = 'unsafeTurn',
  UnsafeVehicle = 'unsafeVehicle',
  ViewObstructed = 'viewObstructed',
  WrongWayOnOneWay = 'wrongWayOnOneWay',

  // Severity major (10)
  FailingToReportAccident = 'failingReportAccident',
  FailureToReportDamageHighway = 'failureReportDamageHighway',
  FalseStatementInsurance = 'falseStatementInsurance',
  MajorConvictionNotSpecified = 'majorConvictionNotSpecified',
  OperateMotorVehicleWithoutInsurance = 'operateMotorVehicleWithoutInsurance',
  ProduceFalseInsurance = 'produceFalseInsurance',
  SchoolBusFailStop = 'schoolBusFailStop',
  SchoolPlaygroundImproperPassing = 'schoolPlaygroundImproperPassing',
  Stunting = 'stunting',
  VehicleOwnerWithoutInsurance = 'vehicleOwnerWithoutInsurance',

  // Severity criminal (13)
  BloodAlcohol = 'bloodAlcohol',
  CarelessDriving = 'carelessDriving',
  CriminalNegligence = 'criminalNegligence',
  DangerousDriving = 'dangerousDriving',
  DrivingWhileUnderSuspension = 'drivingWhileUnderSuspension',
  FailingToObeyPolice = 'failingObeyPolice',
  FailingToRemain = 'failingRemain',
  ImpairedDriving = 'impairedDriving',
  MotorManslaughter = 'motorManslaughter',
  Racing = 'racing',
  RefuseBreathalyzer = 'refuseBreathalyzer',
  SeriousConvictionNotSpecified = 'seriousConvictionNotSpecified',
}

// Criminal driving convictions uses the same list in backend with fortus
// in fortus-types file
export const CriminalDrivingConvictions: DrivingConvictionDescription[] = [
  DrivingConvictionDescription.BloodAlcohol,
  DrivingConvictionDescription.CarelessDriving,
  DrivingConvictionDescription.CriminalNegligence,
  DrivingConvictionDescription.DangerousDriving,
  DrivingConvictionDescription.DrivingWhileUnderSuspension,
  DrivingConvictionDescription.FailingToObeyPolice,
  DrivingConvictionDescription.FailingToRemain,
  DrivingConvictionDescription.ImpairedDriving,
  DrivingConvictionDescription.MotorManslaughter,
  DrivingConvictionDescription.Racing,
  DrivingConvictionDescription.RefuseBreathalyzer,
  DrivingConvictionDescription.SeriousConvictionNotSpecified,
];

// Represent all possible discount choices
export enum Discounts {
  Married = 'married',
  Retired = 'retired',
  Student = 'student',
  UniversityDegree = 'universityDegree',
  WorkFullTime = 'workFullTime',
  WorkPartTime = 'workPartTime',
}

// Represent the status of the driver on the car (main/occasional driver)
export enum DriverType {
  MainDriver = 'mainDriver',
  OccasionalDriver = 'occasionalDriver',
  None = 'none',
}

// Financial institution
export enum FinancialInstitution {
  AlternaBank = 'alternaBank',
  AlternaSavings = 'alternaSavings',
  BankofMontreal = 'bankofMontreal',
  CaisseAlliance = 'caisseAlliance',
  CanadianWesternBank = 'canadianWesternBank',
  Central1CreditUnion = 'central1CreditUnion',
  Cibc = 'cibc',
  DesjardinsGroup = 'desjardinsGroup',
  DesjardinsOntarioCreditUnion = 'desjardinsOntarioCreditUnion',
  EquitableBank = 'equitableBank',
  HsbcBank = 'hsbcBank',
  LaurentianBank = 'laurentianBank',
  ManulifeBank = 'manulifeBank',
  MeridianCreditUnion = 'meridianCreditUnion',
  Motusbank = 'motusbank',
  NationalBank = 'nationalBank',
  PeoplesTrustBank = 'peoplesTrustBank',
  PresidentChoiceBank = 'presidentChoiceBank',
  RoyalBank = 'royalBank',
  Scotiabank = 'scotiabank',
  TangerineBank = 'tangerineBank',
  TdBank = 'tdBank',
  VancityBank = 'vancityBank',
  WealthOneBank = 'wealthOneBank',
  Wealthsimple = 'wealthsimple',
}

// Represent all FireHouseDistance types
export enum FireHouseDistance {
  Within8km = 'within8km',
  Between8and13km = 'between8and13km',
  Over13km = 'over13km',
}

// Represent all possible gender choices
export enum Gender {
  Female = 'female',
  Male = 'male',
}

// All exterior type material
export enum HomeExteriorMaterial {
  Aluminium = 'aluminium',
  Masonry = 'masonry',
  Stone = 'stone',
  Stuco = 'stuco',
  Vinyl = 'vinyl',
  Wood = 'wood',
}

// Represent all possible home security device choices
export enum HomeSecurity {
  BurglarAlarm = 'linkedBurglarAlarm',
  FireAlarm = 'linkedFireAlarm',
  SmokeDetector = 'smokeDetector',
  SmokeFreeHousehold = 'smokeFreeHousehold',
}

// Home structure type choices
export enum HomeStructureType {
  Detached = 'detached',
  SemiDetached = 'semiDetached',
  InRowBuilding = 'inRowBuilding',
  EndRowBuilding = 'endRowBuilding',
}

// Represent all home claim description types
export enum HomeClaimDescription {
  AirConditioner = 'airConditioner',
  BodilyInjury = 'bodilyInjury',
  Burglary = 'burglary',
  CardFraud = 'cardFraud',
  Earthquake = 'earthquake',
  Explosion = 'explosion',
  ExteriorWaterLine = 'exteriorWaterLine',
  ExteriorSewerLine = 'exteriorSewerLine',
  Fire = 'fire',
  FloodWater = 'floodWater',
  GroundWater = 'groundWater',
  GlassBreakage = 'glass',
  IdentityTheft = 'identityTheft',
  Other = 'other',
  PersonalPropertyDamage = 'personalProperty',
  SewerBackup = 'sewerBackup',
  Vandalism = 'vandalism',
  WaterGround = 'water',
  Windstorm = 'windstorm',
}

// Mortgage financial institution
export enum MortgageLenders {
  CibcBank = 'cibcBank',
  CanadaDevelopmentBank = 'canadaDevelopmentBank',
  HSBCBank = 'hscbBank',
  LaurentianBank = 'laurentianBank',
  ManulifeBank = 'manulifeBank',
  NationalBank = 'nationalBank',
  RoyalBank = 'royalBank',
  ScotiaBank = 'scotiaBank',
  DesjardinsGroup = 'desjardinsGroup',
  CitiBank = 'citiBank',
  ComputershareTrustCompany = 'computershareTrustCompany',
  FirstNational = 'firstNational',
  InvestorsGroup = 'investorsGroup',
  IndustrialAlliance = 'industrialAlliance',
  IngBank = 'ingBank',
  QuebecInvestment = 'quebecInvestment',
  JohnDeere = 'johnDeere',
  Kubota = 'kubota',
  Capital = 'laCapitale',
  MontrealTrustCompany = 'montrealTrustCompany',
  PeoplesTrustCompany = 'peoplesTrustCompany',
  SCHL = 'schl',
  StandardLife = 'standardLife',
  TangerineBank = 'tangerineBank',
  TdBank = 'tdBank',
}

// Oil tank location
export enum OilTankLocation {
  InsideAndAboveGround = 'insideAndAboveGround',
  InsideAndInGround = 'insideAndInGround',
  OutsideAndInGround = 'outsideAndInGround',
  OutsideAndAboveGround = 'outsideAndAboveGround',
}

// Represent all dwelling type choices
export enum OwnershipType {
  Condo = 'condo',
  Plex = 'plex',
  SingleHouse = 'house',
}

// Represent all possible primary heating choices
export enum PrimaryHeating {
  Electric = 'electric',
  HotWater = 'hotWater',
  Oil = 'oil',
  Gas = 'gas',
  Wood = 'wood',
}

// Represent all possible pet choices
export enum Pets {
  Cat = 'cat',
  Dog = 'dog',
  Other = 'other',
}

// Represent all relationship types
export enum Relationship {
  BoyfriendOrGirlfriend = 'boyfriendOrGirlfriend',

  // Do not display for Car insurance
  MarriedOrCivilUnion = 'marriedOrCivilUnion',
  Roomate = 'roomate',

  // Do not display for Home insurance
  Family = 'family',
  Other = 'other',
}

// Represent all fire hydrant distance types
export enum FireHydrantDistance {
  Over300m = 'over300m',
  Within300m = 'within300m',
}

export enum YearlyDaysOutsideOfProvince {
  TwentyOne = 'twentyOne', // Less than 3 weeks
  FortyNine = 'fortyNine', // 4 to 7 weeks
  OneHundredFive = 'oneHundredFive', // 8 to 15 weeks
  Never = 'never',
  OneHundredEightyTwo = 'oneHundredEightyTwo', // 16 to 26 weeks
  OneHundredEightyNine = 'oneHundredEightyNine', // over 26 weeks
}
